import * as React from 'react'

import { ResourceGroupHeader } from '~/client/src/shared/components/GroupHeader'
import { useResolveGroupPresentation } from '~/client/src/shared/resources/presentation/resolveGroupPresentation'

import { IResourceProperty, RenderGroupHeader } from './types'

interface IProps {
  group: Parameters<RenderGroupHeader>[0]
  onToggle: Parameters<RenderGroupHeader>[1]
  grouping: string | undefined
  properties: IResourceProperty[]
  /** Required alongside `grouping` for a field to contribute group artwork - see
   * IResolveGroupPresentationArgs on why the name alone cannot identify a field. */
  resourceTypeId?: string
  className?: string
}

const ResourceCardListGroupHeader: React.FC<IProps> = ({
  group,
  onToggle,
  grouping,
  properties,
  resourceTypeId,
  className,
}) => {
  const resolveGroupPresentation = useResolveGroupPresentation()

  const groupingPropertyConfig = React.useMemo(
    () =>
      grouping
        ? properties.find(p => p.name === grouping)?.configuration
        : undefined,
    [grouping, properties],
  )

  const presentation = resolveGroupPresentation({
    propertyConfig: groupingPropertyConfig,
    groupKey: group.key,
    count: group.count,
    propertyName: grouping,
    resourceTypeId,
  })

  return (
    <ResourceGroupHeader
      label={group.label}
      count={group.count}
      depth={group.depth}
      isExpanded={!group.isCollapsed}
      onToggle={onToggle}
      presentation={presentation}
      className={className}
    />
  )
}

export default React.memo(ResourceCardListGroupHeader)
